<template>
  <div class="tournament-info-wrapper_game-selector">
    <div
      class="d-flex justify-content-between align-items-start select-game-title-main"
    >
      <Subheader
        :text="$$t('Select game')"
        class="flex-grow-1 mb-5 select-game-title"
      />
      <div class="flex-grow-0">
        <HeraSearchInput
          v-model="gameSearchModel"
          :placeholder="$$t('Search', 'search')"
          :debounce="700"
          class="hera-search-custom"
          @input="setActiveGame(gamesList[0])"
        />
      </div>
    </div>
    <CarouselSelector
      key="carouselGameSelector"
      v-model="game"
      type="game"
      variant="large"
      required
      :read-only="isTournamentFieldDisabled('game')"
      :label="$$t('Games:', 'games_label')"
      :items="gamesList"
      :empty-text="
        $$t(`We can't find game with this name`, 'games_selector_empty')
      "
      class="tournament-info-wrapper__game-carousel"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import HeraSearchInput from '@/components/molecules/form/HeraSearchInput';
import CarouselSelector from '@/components/common/CarouselSelector';
import Subheader from '@/components/atoms/Subheader';

import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentGameSection',
  inject: ['$validator'],
  components: {
    CarouselSelector,
    HeraSearchInput,
    Subheader,
  },
  mixins: [translate('_web_tournament_settings')],

  data() {
    return {
      gameSearchModel: '',
    };
  },
  computed: {
    ...mapGetters([
      'currentTournament',
      'publishedGames',
      'gameByID',
      'isTournamentFieldDisabled',
    ]),
    hasGame() {
      return this.game && this.game.id;
    },
    game: {
      get() {
        const game = this.$lodash.get(
          this.currentTournament,
          'info.game',
          false
        );
        return game ? this.gameByID(game) || {} : {};
      },
      set(newVal, oldVal) {
        if (!this.$lodash.isEqual(newVal, oldVal)) {
          this.updateCurrentTournament([
            {
              game: newVal.id,
              platforms: [newVal.platforms[0]],
              title: newVal.name + ' tournament',
              component: 'info',
            },
            {
              squad_size: 1,
              component: 'players_config',
            },
          ]);
        }
      },
    },
    gamesList: {
      get() {
        const filterBy = this.gameSearchModel.trim().toLowerCase();
        return filterBy
          ? this.publishedGames.filter(game =>
              game.nameLowerCase.includes(filterBy)
            )
          : this.publishedGames;
      },
      set(val) {
        if (!val.length) {
          this.game = null;
        }
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    setActiveGame(item, force = false) {
      if (force || !this.game.id) {
        this.game = item;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tournament-info-wrapper {
  &__game-carousel {
    min-height: 132px;
    padding: 10px 15px 0px 20px;
    margin-bottom: -20px;
    .app-rtl & {
      padding: 10px 20px 0px 20px;
    }
  }
}
.tournament-info-wrapper__game-carousel :nth-child(1) {
  font-size: $hr-text-small !important;
  font-weight: 600;
  padding-bottom: 10px;
}

.select-game-title {
  margin: 20px 0px 0px 20px;
  .app-rtl & {
    margin-right: 20px;
  }
}

.select-game-title-main :nth-child(1) {
  font-size: $hr-heading-5 !important;
}

.hera-search-custom {
  background-color: blue;
  border-radius: 5px;
  margin-top: 20px;
  width: 80%;
}

.hera-search-custom :focus {
  border: 2px solid $hr-bg-accent;
  border-radius: 5px;
}
</style>
